import Model from '@/core/models/Model';

export default class RequiredDocument extends Model {
  resource() {
    return 'required-documents';
  }
}
